export default __webpack_public_path__ + "static/media/MaximaSeguranca.55c5a379.svg";